import React from 'react';
import SurveyLayout from '@components/_struct/_layouts/SurveyLayout/SurveyLayout';
import styled from 'styled-components';
import HomeContactBlock from './HomeContactBlock';

const SectionForm = styled.section`
    max-width: 600px;
    width: 100%;
    &.enter {
        opacity: 0;
        transform: translateY(80px);
    }
    &.enter-active {
        opacity: 1;
        transform: translateX(0) translateY(0);
        transition: opacity 700ms, transform 700ms;
    }
`;

const ContactPage = () => {
    return (
        <SurveyLayout showLogo={true} variant='singlepage'>
            <div className='px-1 flex-1 flex flex-col'>
                <SectionForm className='m-auto relative'>
                    <HomeContactBlock />
                </SectionForm>
            </div>
        </SurveyLayout>
    );
};

export default ContactPage;
